export default "__VITE_ASSET__DLitIXg2__"